__turbopack_context__.v({
  "filtersRow": "news-filters-module__IzGAuq__filtersRow",
  "newsFilters": "news-filters-module__IzGAuq__newsFilters",
});
